// extracted by mini-css-extract-plugin
export default {"container":"TaskForm_container__34-KA","form":"TaskForm_form__i5ZUr","input":"TaskForm_input__xJ5uF","title":"TaskForm_title__XlAdb","btn":"TaskForm_btn__hSSx5"};